var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "swiper",
    {
      ref: "mySwiper",
      staticClass: "foobar",
      attrs: { options: _vm.swiperOptions },
    },
    [
      _vm._l(_vm.$slots, function (_, name) {
        return _vm._t(name, null, { slot: name })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }